import React from 'react';
import { TableRow, TableCell } from '@mui/material';

const FindCustomerTableRow = ({
  id,
  onClick,
  name = '',
  email = '',
  number = '',
  status = '',
  msgmax = '',
  centre = '',
}) => (
  <TableRow key={id} id={id} onClick={onClick} hover>
    <TableCell>{name}</TableCell>
    <TableCell>{email}</TableCell>
    <TableCell>{number}</TableCell>
    <TableCell>{status}</TableCell>
    <TableCell>{msgmax}</TableCell>
    {/* <TableCell className="medium">{version}</TableCell> */}
    <TableCell>{centre}</TableCell>
  </TableRow>
);

export default FindCustomerTableRow;
